import { withCurrentParams } from 'actions/utils';
import { BROADCAST_SYNC_BANNERS } from 'actions/Types';

export default () => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_SYNC_BANNERS,
      request: async apiClient => {
        return await apiClient.broadcast.get(teamId, eventId, broadcastId);
      }
    };
    dispatch(action);
  });
};
